import { widgetId } from '../../../../../constants/widgetId'
import { WidgetId } from '../../../../../types/widgetId'

export function isValidWidgetId(id: unknown): id is WidgetId {
  return typeof id === 'string' && Object.values(widgetId).includes(id as WidgetId)
}
